export default __webpack_public_path__ + "static/media/category.37a1498a.svg";